import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

const ConnectSupport: LoadableType<
	Omit<
		{
			flags: any;
		},
		'flags'
	>
> = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ConnectSupport" */ './ConnectSupport.tsx'))
			.ConnectSupport,
});

export { ConnectSupport };
